import { useState, useEffect } from 'react';
import { useTelegram } from './useTelegram';

/**
 * Хук для отслеживания статуса сети (Online/Offline)
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}

/**
 * Хук для предотвращения случайного закрытия Mini App свайпом вниз при редактировании форм
 */
export function useSwipeProtection(isDirty: boolean) {
  const { tg } = useTelegram();

  useEffect(() => {
    if (isDirty && tg) {
      tg.enableClosingConfirmation?.();
    } else if (tg) {
      tg.disableClosingConfirmation?.();
    }
  }, [isDirty, tg]);
}

/**
 * Хук для автоматической прокрутки сфокусированных input-полей во WebView
 */
export function useKeyboardResilience() {
  useEffect(() => {
    const handleFocusIn = (e: FocusEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 150);
      }
    };

    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);
}
